<template>
<div class="spark-screen container">
    <div class="row justify-content-center">
        <div class="col-lg-8">
            <card role="form">
                <card-header>Complete Company Account</card-header>
                <card-body>
                    <div class="form-group row"><label class="col-md-4 col-form-label text-md-right">Company</label>
                        <div class="col-md-6">
                            <input-text type="text" v-model="registerForm.team" :form="registerForm" field="team"></input-text><span class="invalid-feedback"></span></div>
                    </div>
                    <div class="form-group row"><label class="col-md-4 col-form-label text-md-right">Name</label>
                        <div class="col-md-6">
                            <input-text type="text" v-model="registerForm.name" :form="registerForm" field="name"></input-text>
                        </div>
                    </div>
                    <div class="form-group row"><label class="col-md-4 col-form-label text-md-right">E-Mail Address</label>
                        <div class="col-md-6">
                            <input-text type="text" v-model="registerForm.email" :form="registerForm" field="email"></input-text>
                        </div>
                    </div>
                    <div class="form-group row"><label class="col-md-4 col-form-label text-md-right">Country code/Area code</label>
                        <div class="col-md-6">
                            <international-twilio-phone :register_form="registerForm"></international-twilio-phone>
                        </div>
                    </div>
                    <div class="form-group row"><label class="col-md-4 col-form-label text-md-right">Password</label>
                        <div class="col-md-6">
                            <input-text type="password" v-model="registerForm.password" :form="registerForm" field="password"></input-text>
                        </div>
                    </div>
                    <div class="form-group row"><label class="col-md-4 col-form-label text-md-right">Confirm Password</label>
                        <div class="col-md-6">
                            <input-text type="password" v-model="registerForm.password_confirmation" :form="registerForm" field="password_confirmation"></input-text>
                        </div>
                    </div>
                    <div class="form-group row" :class="{'is-invalid': registerForm.errors.has('terms')}">
                        <div class="col-md-6 offset-md-4">
                            <div class="form-check"><label class="form-check-label"><input class="form-check-input" type="checkbox" v-model="registerForm.terms"/>I Accept&nbsp;<a href="https://www.swellcx.com/terms-and-conditions" target="_blank">The Terms Of Service</a> and&nbsp;<a href="https://www.swellcx.com/user-license-agreement" target="_blank">User License Agreement</a></label>
                                <span
                                    class="invalid-feedback" v-show="registerForm.errors.has('terms')"><strong>{{ registerForm.errors.get('terms') }}</strong></span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group row mb-0">
                        <div class="col-md-6 offset-md-4"><button class="btn btn-primary" @click.prevent="register" :disabled="registerForm.busy"><span v-if="registerForm.busy"><i class="fa fa-btn fa-spinner fa-spin"></i> Registering</span><span v-else=""><i class="fa fa-btn fa-check-circle"></i> Register</span></button></div>
                    </div>
                </card-body>
            </card>
        </div>
    </div>
</div>
</template>

<script>
export default {

    props: ['team', 'owner'],

    data: () => ({
        registerForm: $.extend(true, new SparkForm({
            stripe_token: '',
            plan: '',
            team: '',
            team_id: '',
            user_id: '',
            team_slug: '',
            name: '',
            email: '',
            password: '',
            password_confirmation: '',
            address: '',
            address_line_2: '',
            city: '',
            state: '',
            zip: '',
            country_code: 'US',
            area_code: null,
            vat_id: '',
            terms: false,
            coupon: null,
            invitation: null,
            was_invited: false
        }), Spark.forms.register)
    }),

    created() {
        this.registerForm.team = this.team.name
        this.registerForm.name = this.owner.name
        this.registerForm.email = this.owner.email
        this.registerForm.team_id = this.team.id
        this.registerForm.user_id = this.owner.id
    },

    computed: {
        updateUrl() { return this.$laroute.route('update-invited-company') }
    },

    methods: {
        sendRegistration() {
            Spark.put(this.updateUrl, this.registerForm)
                .then(({ redirect }) => {
                    this.registerForm.busy = true;
                    window.location = redirect;
                });
        },

        register() {
            this.registerForm.busy = true;
            this.registerForm.errors.forget();
            return this.sendRegistration();
        }
    }

}
</script>
